/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getFieldZoneLayout } from "cms/fields/layout/get-field-zone-layout";
import { MultiLineFieldDisplay } from "./display";
import { MultiLineFieldEdit } from "./edit";

const MultiLineField = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <MultiLineFieldDisplay />,
        editComponent: <MultiLineFieldEdit />,
    };
    return getFieldZoneLayout(zoneProps);
};
MultiLineField.displayName = "MultiLineField";
export { MultiLineField };
